import { IconProps } from '../types';

export const WarningIcon = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={15} height={13} fill="none" {...props}>
    <path
      fill="#C65C10"
      d="m7.595.333 6.35 11a.667.667 0 0 1-.577 1H.667a.667.667 0 0 1-.578-1l6.351-11a.667.667 0 0 1 1.155 0ZM1.82 11h10.393L7.018 2 1.82 11Zm4.53-2h1.333v1.334H6.351V9Zm0-4.667h1.333v3.334H6.351V4.333Z"
    />
  </svg>
);
